/* eslint-disable @typescript-eslint/no-explicit-any */
import { KeyValue } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'errorKey',
    standalone: true
})
export class ErrorKeyPipe implements PipeTransform {
    /**
     * filtra la lista degli errori in formato KeyValue per valore di key
     *
     * @param value formControl.errors
     * @param args key errore da filtrare
     * @returns
     */
    transform(value: KeyValue<string, unknown>[], ...args: string[]) {
        return value.filter((x: any) => args.includes(x.key));
    }
}
